import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class Bubble extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0,0, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Bubble_1);

    this.scene.add.existing(this);
    this.visible = false;
  }

  reset (x,y,scale,speed) {
    this.x = x;
    this.y = y;
    this.scale = scale;
    this.vY = speed;
    this.visible = true;
  }

  tick(delta) {
    this.y -= delta * this.vY;
  }
}